// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","985":"component---src-pages-ss-[name]-js"}[chunkId] || chunkId) + "-" + {"351":"5d3175716eca7f788ff4","480":"4627f2ee2db627f24ee5","499":"e126b804259bbdb52f88","678":"dfc496ecb6c566438e4d","794":"0b80a8d318b02a375cec","985":"fed3b4ae1d6e7a6a0261"}[chunkId] + ".js";
};